// TinyMCE toolbar on narrow screens: one row, and the buttons that do not fit
// open in a second row under it (the "…" button) instead of a floating panel.
// TinyMCE gives the phones and tablets it recognises its own default mode
// ("scrolling") unless the mobile section names one too.
export const editorToolbarInit = {
  toolbar_mode: "sliding",
  mobile: { toolbar_mode: "sliding" },
} as const;
